import React from 'react'
import * as Menu from '../../components/menu'

export const routes = [
  {
    action: () => import('./component'/* webpackChunkName:  "UpcomingSchedule Page" */)
       .then(({UpcomingScheduleConnected}) => <UpcomingScheduleConnected />),
    path: Menu.ADMIN_UPCOMING_SCHEDULES_URL,
  },
]



// WEBPACK FOOTER //
// ./src/pages/upcoming-schedules/routes.tsx